import { AppConfigData, IStaticTable } from '@models/shared/config/config';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { APP_CONFIG } from '../tokens/app-config.token';

@Injectable({
  providedIn: 'root'
})
export class StaticDataService {
  private httpClient = inject(HttpClient);
  private appConfigToken = inject(APP_CONFIG);

  baseURL = this.appConfigToken.apiUrl;
  baseURLCRUD = this.appConfigToken.apiUrl + 'api/staticData';
  configData: IStaticTable[] = [];
  appConfig!: AppConfigData;
  isAppLoaded = false;

  private staticData$ = new BehaviorSubject<AppConfigData>(null as any);
  private staticDataSignal$ = signal<AppConfigData>(null as any);

  constructor() {
    this.loadData();
  }

  public loadData() {
    this.getAllConfigurations().subscribe(data => {
      this.appConfig = data;
      AppConfigData.config$ = this.subscribeDataConfig();

      // Emitting Event
      this.staticData$.next(this.appConfig);
      this.staticDataSignal$.set(this.appConfig);
      this.isAppLoaded = true;
    });
  }

  public subscribeDataConfig(): Observable<AppConfigData> {
    return this.staticData$.asObservable();
  }

  public subscribeDataSignal(): any {
    return this.staticDataSignal$;
  }

  private getAllConfigurations() {
    return this.httpClient.get<AppConfigData>(`${this.baseURL}appdata`);
  }

  public getContactTypeByID(typeID: number): any {
    return this.appConfig?.contactTypes?.find((c: any) => c.contact_type_id === typeID);
  }

  public getContactTypeByCd(cd: string): any {
    return this.appConfig?.contactTypes?.find((c: any) => c.contact_type_code === cd);
  }

  public isContactTypeGroup(contact_type_id: number): boolean {
    let status = false;
    if (contact_type_id) {
      try {
        if (this.getGroupNameByTypeId(contact_type_id)) {
          status = true;
        }
      } catch (error) {
        console.error(error);
      }
    }
    return status;
  }

  public getGroupNameByTypeId(contact_type_id: number): string | null {
    let name = null;
    this.appConfig?.contactTypes?.forEach(t => {
      if (t.contact_type_id === contact_type_id) {
        if (t.contact_type_code.split("-")[1] === 'group') {
          name = t.contact_type_code.split("-")[0];
        }
      }
    });
    return name;
  }
}
